// extracted by mini-css-extract-plugin
export default {"suggestionText":"SuggestionComponent_suggestionText__EjEga","pandaImg":"SuggestionComponent_pandaImg__ARCTC"};